import {useAppSelector} from "../../../redux/hooks";
import {dashboardStore} from "../store/dashboardPageStore";
import {IDashboardPageRecentlyPlayedLesson} from "../store/IDashboardPageStore";

export interface IRecentlyPlayedLogic {
  lessons: IDashboardPageRecentlyPlayedLesson[];
}

export const useRecentlyPlayedLogic = (): IRecentlyPlayedLogic => {
  const lessons = useAppSelector(() => dashboardStore.getRecentlyPlayed().lessons);

  return {
    lessons,
  };
}
